/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export var AuditLogActionFlagEnum = /*#__PURE__*/function (AuditLogActionFlagEnum) {
  AuditLogActionFlagEnum["ADDITION"] = "ADDITION";
  AuditLogActionFlagEnum["CHANGE"] = "CHANGE";
  AuditLogActionFlagEnum["DELETION"] = "DELETION";
  return AuditLogActionFlagEnum;
}({});
export var AuditLogActionLangEnum = /*#__PURE__*/function (AuditLogActionLangEnum) {
  AuditLogActionLangEnum["ES"] = "ES";
  AuditLogActionLangEnum["PT"] = "PT";
  return AuditLogActionLangEnum;
}({});
export var AuditLogContentTypeEnum = /*#__PURE__*/function (AuditLogContentTypeEnum) {
  AuditLogContentTypeEnum["COURSE"] = "COURSE";
  AuditLogContentTypeEnum["GAMIFICATION"] = "GAMIFICATION";
  AuditLogContentTypeEnum["QUIZ"] = "QUIZ";
  return AuditLogContentTypeEnum;
}({});
export var AuditLogOrderFieldEnum = /*#__PURE__*/function (AuditLogOrderFieldEnum) {
  AuditLogOrderFieldEnum["ACTION_TIME"] = "ACTION_TIME";
  AuditLogOrderFieldEnum["CREATED_AT"] = "CREATED_AT";
  AuditLogOrderFieldEnum["ID"] = "ID";
  return AuditLogOrderFieldEnum;
}({});
export var CourseComponentTypeEnum = /*#__PURE__*/function (CourseComponentTypeEnum) {
  CourseComponentTypeEnum["BASIC"] = "BASIC";
  CourseComponentTypeEnum["CERTIFICATION_REQUIREMENT"] = "CERTIFICATION_REQUIREMENT";
  CourseComponentTypeEnum["CONFIG"] = "CONFIG";
  CourseComponentTypeEnum["MENTORING_ASSIGNMENT"] = "MENTORING_ASSIGNMENT";
  CourseComponentTypeEnum["MODULE"] = "MODULE";
  CourseComponentTypeEnum["VIDEO_LECTURE"] = "VIDEO_LECTURE";
  return CourseComponentTypeEnum;
}({});
export var CurrencyEventEnum = /*#__PURE__*/function (CurrencyEventEnum) {
  CurrencyEventEnum["CREATED_AT"] = "CREATED_AT";
  CurrencyEventEnum["ID"] = "ID";
  CurrencyEventEnum["VALUE"] = "VALUE";
  return CurrencyEventEnum;
}({});

/**
 * Currency Events fields enum to order queryset
 */
export var CurrencyEventFieldsEnum = /*#__PURE__*/function (CurrencyEventFieldsEnum) {
  CurrencyEventFieldsEnum["CREATED_AT"] = "CREATED_AT";
  CurrencyEventFieldsEnum["ID"] = "ID";
  CurrencyEventFieldsEnum["VALUE"] = "VALUE";
  return CurrencyEventFieldsEnum;
}({});

/**
 * Currency Points fields enum to order queryset
 */
export var CurrencyPointFieldsEnum = /*#__PURE__*/function (CurrencyPointFieldsEnum) {
  CurrencyPointFieldsEnum["CREATED_AT"] = "CREATED_AT";
  CurrencyPointFieldsEnum["ID"] = "ID";
  return CurrencyPointFieldsEnum;
}({});
export var CurrencyPointStatusEnum = /*#__PURE__*/function (CurrencyPointStatusEnum) {
  CurrencyPointStatusEnum["DRAFT"] = "DRAFT";
  CurrencyPointStatusEnum["PUBLISHED"] = "PUBLISHED";
  return CurrencyPointStatusEnum;
}({});
export var EventSubjectEnum = /*#__PURE__*/function (EventSubjectEnum) {
  EventSubjectEnum["COMPLETE_COURSE"] = "COMPLETE_COURSE";
  EventSubjectEnum["COMPLETE_PROJECT"] = "COMPLETE_PROJECT";
  EventSubjectEnum["COMPLETE_QUIZ"] = "COMPLETE_QUIZ";
  EventSubjectEnum["LEARNING_PATH"] = "LEARNING_PATH";
  return EventSubjectEnum;
}({});
export var EventTypeEnum = /*#__PURE__*/function (EventTypeEnum) {
  EventTypeEnum["ACHIEVEMENT"] = "ACHIEVEMENT";
  EventTypeEnum["EVENT"] = "EVENT";
  return EventTypeEnum;
}({});
export var ObjectTypeEnum = /*#__PURE__*/function (ObjectTypeEnum) {
  ObjectTypeEnum["TYPE_COURSE"] = "TYPE_COURSE";
  ObjectTypeEnum["TYPE_LEARNING_PATH"] = "TYPE_LEARNING_PATH";
  ObjectTypeEnum["TYPE_PROJECT"] = "TYPE_PROJECT";
  ObjectTypeEnum["TYPE_QUIZ"] = "TYPE_QUIZ";
  return ObjectTypeEnum;
}({});
export var OrderDirectionEnum = /*#__PURE__*/function (OrderDirectionEnum) {
  OrderDirectionEnum["ASC"] = "ASC";
  OrderDirectionEnum["DESC"] = "DESC";
  return OrderDirectionEnum;
}({});

/**
 * Reward fields enum to order queryset
 */
export var RewardFieldsEnum = /*#__PURE__*/function (RewardFieldsEnum) {
  RewardFieldsEnum["CREATED_AT"] = "CREATED_AT";
  RewardFieldsEnum["ID"] = "ID";
  return RewardFieldsEnum;
}({});
export var RewardStatusEnum = /*#__PURE__*/function (RewardStatusEnum) {
  RewardStatusEnum["STATUS_ACTIVE"] = "STATUS_ACTIVE";
  RewardStatusEnum["STATUS_DRAFT"] = "STATUS_DRAFT";
  RewardStatusEnum["STATUS_EXPIRED"] = "STATUS_EXPIRED";
  RewardStatusEnum["STATUS_INACTIVE"] = "STATUS_INACTIVE";
  return RewardStatusEnum;
}({});
export var TransactionStatusEnum = /*#__PURE__*/function (TransactionStatusEnum) {
  TransactionStatusEnum["STATUS_DONE"] = "STATUS_DONE";
  TransactionStatusEnum["STATUS_PENDING"] = "STATUS_PENDING";
  return TransactionStatusEnum;
}({});
export var TransactionTypeEnum = /*#__PURE__*/function (TransactionTypeEnum) {
  TransactionTypeEnum["TYPE_ADJUSTMENT"] = "TYPE_ADJUSTMENT";
  TransactionTypeEnum["TYPE_EXCHANGED"] = "TYPE_EXCHANGED";
  TransactionTypeEnum["TYPE_STOCKING"] = "TYPE_STOCKING";
  return TransactionTypeEnum;
}({});
export var VideoLectureSubComponentTypeEnum = /*#__PURE__*/function (VideoLectureSubComponentTypeEnum) {
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_BREAK"] = "VIDEO_LECTURE_BREAK";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_CLASS"] = "VIDEO_LECTURE_CLASS";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_EXERCISE"] = "VIDEO_LECTURE_EXERCISE";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_IFRAME"] = "VIDEO_LECTURE_IFRAME";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_LIVE_SESSION"] = "VIDEO_LECTURE_LIVE_SESSION";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_PDF"] = "VIDEO_LECTURE_PDF";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_QUIZ"] = "VIDEO_LECTURE_QUIZ";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_SCORM"] = "VIDEO_LECTURE_SCORM";
  VideoLectureSubComponentTypeEnum["VIDEO_LECTURE_SURVEY"] = "VIDEO_LECTURE_SURVEY";
  return VideoLectureSubComponentTypeEnum;
}({});

/**
 * Currency Event order by input
 */

//==============================================================
// END Enums and Input Objects
//==============================================================